<template>
  <div class="text-center">
    <v-dialog v-model="dialog_plan_conditions" width="500">
      <template v-slot:activator="{ on, attrs }">
        <v-layout align-center justify-center row fill-height>
          <v-btn v-bind="attrs" v-on="on" flat small>
            <div
              v-if="!plan.name.startsWith('Black')"
              class="text-decoration-underline text-capitalize black--text"
            >
              Mais informações
            </div>
            <div
              v-if="plan.name.startsWith('Black')"
              class="text-decoration-underline text-capitalize black--text"
            >
              <br />*Após o primeiro ano, o desconto será de 13%<br />Desconto
              condicionado ao pagamento da fatura até o vencimento.
            </div>
          </v-btn>
        </v-layout>
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Plano: {{ plan ? plan.name : "" }}
        </v-card-title>
        <p class=".subtitle-1 pa-3">Condições</p>
        <v-card-text v-html="plan.conditions" />

        <!-- <p class=".subtitle-1 pa-3">Regras de Cancelamento</p> -->
        <!-- <v-card-text v-html="plan & plan.cancelation_conditions ? plan.cancelation_conditions.penalty : ''"/> -->
        <v-card-text v-html="penalty" />

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue" text @click="dialog_plan_conditions = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { eventBus } from "../../main";
export default {
  props: ["plan"],
  data() {
    return {
      dialog_plan_conditions: false,
    };
  },
  computed: {
    penalty() {
      return this.plan && this.plan.cancelation_conditions
        ? this.plan.cancelation_conditions.penalty
        : "";
    },
  },
  mounted() {
    eventBus.$on("dialog_plan_conditions", async () => {
      this.dialog_plan_conditions = true;
    });
  },
};
</script>
